export default "__VITE_ASSET__BufRklAJ__"